<template>
<div>

<h1>Berabere Kaldınız!</h1>

<button @click="again">Tekrar Oyna</button>

</div>

</template>


<script>

export default {
    methods: {
        again() {
             this.$emit("againEvent", "start-game") 
        }
    }

}


</script>


<style scoped>

h1 {
    font-size: 2.8rem;
    color: #fff;
    padding-bottom: 0.8rem;
    
}

button {
    cursor: pointer;
    font-size: 2rem;
    background-color: #fff;
    color:green;
    padding: 0.4rem 1.2rem;
    border:none;
    transition: .6s;
}

button:hover {
    opacity: 0.8;
}

</style>